import { render, staticRenderFns } from "./DataUpdates.vue?vue&type=template&id=04590728&"
import script from "./DataUpdates.vue?vue&type=script&lang=js&"
export * from "./DataUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/DataUpdates.vue
// module id = null
// module chunks = 